export const DEFAULT_HEAD_SCRIPTS = `<script async src="https://www.googletagmanager.com/gtag/js?id=AW-16672092592"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-16672092592');
</script>`;
